export default __webpack_public_path__ + "static/media/img4.40713c4e.jpg";